import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp, X, Users, Clock, Calendar } from 'lucide-react';

const RoadmapGantt = () => {
  const [selectedPhase, setSelectedPhase] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [zoom, setZoom] = useState('months'); // 'months' or 'weeks'

  // Roadmap data con todas las tareas
  const phases = [
    {
      name: 'Fase 0: Preparación y baseline',
      weeks: '1-2',
      color: '#F5A623',
      tasks: [
        { id: 1, name: 'Definir alcance MVP SNBL + Kompa Club', start: 1, duration: 2, dependencies: '' },
        { id: 2, name: 'Arquitectura Fase A (FastAPI+Mongo)', start: 1, duration: 2, dependencies: '1' },
        { id: 3, name: 'Setup repos, envs, CI básico', start: 1, duration: 2, dependencies: '2' },
        { id: 4, name: 'Diseño UI kit: componentes shadcn', start: 1, duration: 2, dependencies: '1' },
        { id: 5, name: 'Modelo de datos (UUIDs, repositorios)', start: 1, duration: 2, dependencies: '2' }
      ]
    },
    {
      name: 'Fase 1: Core app usable',
      weeks: '3-10',
      color: '#FF9500',
      tasks: [
        { id: 6, name: 'Auth JWT + refresh (cookies httpOnly), RBAC', start: 3, duration: 2, dependencies: '3,5' },
        { id: 7, name: 'Pantallas: Login/Register/Forgot/Reset', start: 3, duration: 2, dependencies: '6' },
        { id: 8, name: 'Perfil usuario + settings básicos', start: 3, duration: 2, dependencies: '6' },
        { id: 9, name: 'Crear meta (monto, plazo 1–36, frecuencia)', start: 5, duration: 3, dependencies: '5,7' },
        { id: 10, name: 'Ver meta: progreso, proyección, timeline', start: 5, duration: 3, dependencies: '9' },
        { id: 11, name: 'Aportes manuales + recibo + historial', start: 5, duration: 3, dependencies: '10' },
        { id: 12, name: 'Wallet (balance + bolsillos por meta)', start: 8, duration: 3, dependencies: '11' },
        { id: 13, name: 'Ledger entries (depósitos, aportes, fees)', start: 8, duration: 3, dependencies: '12' },
        { id: 14, name: 'Dashboard Home (resumen metas + wallet)', start: 8, duration: 3, dependencies: '10,12' }
      ]
    },
    {
      name: 'Fase 2: Monetización',
      weeks: '11-18',
      color: '#4CAF50',
      tasks: [
        { id: 15, name: 'Módulo Kompa Club (estado, plan, beneficios)', start: 11, duration: 2, dependencies: '6,14' },
        { id: 16, name: 'Regla cambios de esquema: Free vs Club', start: 11, duration: 2, dependencies: '9,15' },
        { id: 17, name: 'Cálculo y visualización indexación', start: 13, duration: 2, dependencies: '13,9' },
        { id: 18, name: 'Admin job "cierre mensual"', start: 13, duration: 2, dependencies: '15,17' },
        { id: 19, name: 'Detección "completed_via"', start: 15, duration: 2, dependencies: '11,17' },
        { id: 20, name: 'Cálculo refund + ledger refund', start: 15, duration: 2, dependencies: '19,18' },
        { id: 21, name: 'UI "refund estimado" en meta', start: 15, duration: 2, dependencies: '20,15' },
        { id: 22, name: 'Auditoría de reglas + pruebas', start: 17, duration: 2, dependencies: '18-21' },
        { id: 23, name: 'Manejo de edge cases: pausa, reactivar', start: 17, duration: 2, dependencies: '16,22' }
      ]
    },
    {
      name: 'Fase 3: Remesas + Aliados',
      weeks: '19-26',
      color: '#2196F3',
      tasks: [
        { id: 24, name: '"Meta pública": link/código remesas', start: 19, duration: 3, dependencies: '9,6' },
        { id: 25, name: 'Registrar remesa (ledger + remitente)', start: 19, duration: 3, dependencies: '24,13' },
        { id: 26, name: 'UI: compartir link + QR + feed remesas', start: 19, duration: 3, dependencies: '25' },
        { id: 27, name: 'Catálogo aliados (CRUD admin)', start: 22, duration: 3, dependencies: '5,6' },
        { id: 28, name: 'UI directorio aliados por categoría', start: 22, duration: 3, dependencies: '27' },
        { id: 29, name: 'Solicitud de ejecución con aliado', start: 22, duration: 3, dependencies: '28,10' },
        { id: 30, name: 'QA end-to-end completo', start: 25, duration: 2, dependencies: '14-29' },
        { id: 31, name: 'Mejoras UX: empty states, loading, errores', start: 25, duration: 2, dependencies: '30' }
      ]
    },
    {
      name: 'Fase 4: Landing SEO + Growth',
      weeks: '27-34',
      color: '#9C27B0',
      tasks: [
        { id: 32, name: 'Landing rutas públicas', start: 27, duration: 3, dependencies: '4' },
        { id: 33, name: 'SSG/prerender Node: HTML visible + meta OG', start: 27, duration: 3, dependencies: '32' },
        { id: 34, name: 'sitemap.xml + robots.txt + canonical', start: 27, duration: 3, dependencies: '33' },
        { id: 35, name: 'Eventos analíticos (funnel)', start: 30, duration: 3, dependencies: '14,32' },
        { id: 36, name: 'Referidos (link de invitación)', start: 30, duration: 3, dependencies: '35' },
        { id: 37, name: 'Email/SMS placeholders', start: 30, duration: 3, dependencies: '35' },
        { id: 38, name: 'Rate limiting + antifraude básico', start: 33, duration: 2, dependencies: '6,25' },
        { id: 39, name: 'Optimización performance', start: 33, duration: 2, dependencies: '33' }
      ]
    },
    {
      name: 'Fase 5: Admin + Operación',
      weeks: '35-44',
      color: '#FF5722',
      tasks: [
        { id: 40, name: 'Admin panel completo', start: 35, duration: 4, dependencies: '6,18,25,29' },
        { id: 41, name: 'Admin "cierre mensual" con logs + reportes', start: 35, duration: 4, dependencies: '18,40' },
        { id: 42, name: 'Herramientas operativas: soporte', start: 39, duration: 3, dependencies: '40' },
        { id: 43, name: 'Auditoría de movimientos + conciliación', start: 39, duration: 3, dependencies: '41' },
        { id: 44, name: 'Hardening: seguridad, backup, monitoreo', start: 42, duration: 3, dependencies: '41,43' }
      ]
    },
    {
      name: 'Fase 6: Postgres + Strapi',
      weeks: '45-58',
      color: '#00BCD4',
      tasks: [
        { id: 45, name: 'Diseñar Content Types Strapi', start: 45, duration: 4, dependencies: '32' },
        { id: 46, name: 'Implementar ContentService', start: 45, duration: 4, dependencies: '45' },
        { id: 47, name: 'Migrar Landing a consumir Strapi', start: 45, duration: 4, dependencies: '46' },
        { id: 48, name: 'Diseñar esquema SQL + scripts migración', start: 49, duration: 4, dependencies: '5,12,13' },
        { id: 49, name: 'Implementar repositorios Postgres', start: 49, duration: 4, dependencies: '48' },
        { id: 50, name: 'Script migración Mongo→Postgres (ETL)', start: 49, duration: 4, dependencies: '49' },
        { id: 51, name: 'Doble escritura / staging dry-run', start: 53, duration: 6, dependencies: '50' },
        { id: 52, name: 'Cutover a Postgres en staging', start: 53, duration: 6, dependencies: '51' },
        { id: 53, name: 'Cutover a producción', start: 53, duration: 6, dependencies: '52' }
      ]
    },
    {
      name: 'Fase 7: Aceleradores + Expansión',
      weeks: '59-78',
      color: '#795548',
      tasks: [
        { id: 54, name: 'Diseño "Impulso final" + scoring', start: 59, duration: 4, dependencies: '35,52' },
        { id: 55, name: 'Integración partner banking (sandbox)', start: 59, duration: 4, dependencies: '54' },
        { id: 56, name: 'Bolsas/Grupos (reglas, transparencia)', start: 63, duration: 4, dependencies: '54' },
        { id: 57, name: 'UI/UX aceleradores + disclaimers', start: 63, duration: 4, dependencies: '56' },
        { id: 58, name: 'Compliance reforzado (KYC escalonado)', start: 67, duration: 6, dependencies: '55-57' },
        { id: 59, name: 'Pilotos controlados por cohortes', start: 67, duration: 6, dependencies: '58' },
        { id: 60, name: 'Optimización CAC→LTV, pricing', start: 73, duration: 6, dependencies: '35,59' },
        { id: 61, name: 'SRE/observabilidad completa, DR plan', start: 73, duration: 6, dependencies: '44' },
        { id: 62, name: 'Localización/expansión multi-país', start: 73, duration: 6, dependencies: '53,60' }
      ]
    }
  ];

  const maxWeek = 78;
  const totalMonths = 18;
  const weeksPerMonth = maxWeek / totalMonths; // 4.33 semanas por mes

  // Calculate week position aligned to month grid
  const getWeekPosition = (week) => {
    // Convert week to month position (0-18)
    const monthPosition = (week - 1) / weeksPerMonth;
    return (monthPosition / totalMonths) * 100;
  };

  const getWeekWidth = (duration) => {
    // Convert duration in weeks to percentage of month grid
    const monthWidth = duration / weeksPerMonth;
    return (monthWidth / totalMonths) * 100;
  };

  // Get all tasks for selected phase
  const getPhaseColor = (phaseIdx) => phases[phaseIdx]?.color || '#666';

  return (
    <div className="roadmap-gantt-container">
      {/* Header Stats */}
      <div className="flex flex-wrap items-center justify-center gap-6 mb-8">
        <div className="flex items-center gap-3">
          <Calendar size={24} className="text-[#F5A623]" />
          <div>
            <p className="text-2xl font-black text-white">{maxWeek}</p>
            <p className="text-sm text-gray-400">semanas</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Users size={24} className="text-[#F5A623]" />
          <div>
            <p className="text-2xl font-black text-white">62</p>
            <p className="text-sm text-gray-400">tareas</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Clock size={24} className="text-[#F5A623]" />
          <div>
            <p className="text-2xl font-black text-white">8</p>
            <p className="text-sm text-gray-400">fases</p>
          </div>
        </div>
      </div>

      {/* Timeline Header - Months */}
      <div className="gantt-timeline-wrapper">
        <div className="gantt-header">
          <div className="gantt-header-label">Fase/Tarea</div>
          <div className="gantt-header-timeline">
            {Array.from({ length: totalMonths }, (_, i) => (
              <div key={i} className="month-marker">
                <span>Mes {i + 1}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Gantt Body */}
        <div className="gantt-body">
          {phases.map((phase, phaseIdx) => (
            <div key={phaseIdx} className="phase-group">
              {/* Phase Row */}
              <div 
                className="phase-row"
                style={{ borderLeftColor: phase.color }}
              >
                <div className="gantt-row-label">
                  <button
                    onClick={() => setSelectedPhase(selectedPhase === phaseIdx ? null : phaseIdx)}
                    className="phase-toggle"
                  >
                    <span className="phase-number" style={{ backgroundColor: phase.color }}>
                      {phaseIdx}
                    </span>
                    <div className="phase-info">
                      <p className="phase-name">{phase.name}</p>
                      <p className="phase-meta">Sem {phase.weeks} • {phase.tasks.length} tareas</p>
                    </div>
                    {selectedPhase === phaseIdx ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </button>
                </div>
                <div className="gantt-row-timeline">
                  <div 
                    className="phase-bar"
                    style={{
                      left: `${getWeekPosition(parseInt(phase.weeks.split('-')[0]))}%`,
                      width: `${getWeekWidth(parseInt(phase.weeks.split('-')[1]) - parseInt(phase.weeks.split('-')[0]) + 1)}%`,
                      backgroundColor: phase.color
                    }}
                  >
                    <span className="phase-bar-label">{phase.weeks}</span>
                  </div>
                </div>
              </div>

              {/* Tasks Rows */}
              <AnimatePresence>
                {selectedPhase === phaseIdx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="tasks-container"
                  >
                    {phase.tasks.map((task) => (
                      <div key={task.id} className="task-row">
                        <div className="gantt-row-label task-label">
                          <span className="task-id" style={{ backgroundColor: phase.color }}>
                            {task.id}
                          </span>
                          <span className="task-name">{task.name}</span>
                        </div>
                        <div className="gantt-row-timeline">
                          <div
                            className="task-bar"
                            style={{
                              left: `${getWeekPosition(task.start)}%`,
                              width: `${getWeekWidth(task.duration)}%`,
                              backgroundColor: phase.color
                            }}
                            onClick={() => setSelectedTask(task.id === selectedTask ? null : task.id)}
                          >
                            <span className="task-bar-label">
                              S{task.start}-{task.start + task.duration}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>

      {/* Task Detail Modal */}
      <AnimatePresence>
        {selectedTask && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="modal-overlay"
              onClick={() => setSelectedTask(null)}
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="modal-content"
            >
              {phases.map(phase => {
                const task = phase.tasks.find(t => t.id === selectedTask);
                if (!task) return null;
                
                return (
                  <div key={task.id}>
                    <div className="modal-header" style={{ backgroundColor: phase.color }}>
                      <div className="flex items-center gap-3">
                        <span className="modal-task-id">{task.id}</span>
                        <div>
                          <h3 className="text-xl font-black text-white">{task.name}</h3>
                          <p className="text-sm text-white/80">{phase.name}</p>
                        </div>
                      </div>
                      <button onClick={() => setSelectedTask(null)} className="modal-close">
                        <X size={24} />
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="modal-detail">
                        <strong>Semana inicio:</strong> {task.start}
                      </div>
                      <div className="modal-detail">
                        <strong>Duración:</strong> {task.duration} semanas
                      </div>
                      <div className="modal-detail">
                        <strong>Semana fin:</strong> {task.start + task.duration}
                      </div>
                      {task.dependencies && (
                        <div className="modal-detail">
                          <strong>Dependencias:</strong> Tareas {task.dependencies}
                        </div>
                      )}
                      <div className="modal-detail">
                        <strong>Fase:</strong> {phase.name}
                      </div>
                    </div>
                  </div>
                );
              })}
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Legend */}
      <div className="legend-container">
        {phases.map((phase, idx) => (
          <div key={idx} className="legend-item">
            <div className="legend-color" style={{ backgroundColor: phase.color }} />
            <div>
              <p className="legend-name">Fase {idx}</p>
              <p className="legend-tasks">{phase.tasks.length} tareas</p>
            </div>
          </div>
        ))}
      </div>

      <style dangerouslySetInnerHTML={{__html: `
        .roadmap-gantt-container {
          background: linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 100%);
          padding: 2rem;
          border-radius: 1.5rem;
        }

        .gantt-timeline-wrapper {
          background: white;
          border-radius: 1rem;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        }

        .gantt-header {
          display: grid;
          grid-template-columns: 300px 1fr;
          border-bottom: 3px solid #F5A623;
          background: #f9f9f9;
        }

        .gantt-header-label {
          padding: 1rem;
          font-weight: 900;
          color: #1A1A1A;
          border-right: 2px solid #e0e0e0;
        }

        .gantt-header-timeline {
          display: grid;
          grid-template-columns: repeat(18, 1fr);
          border-left: 1px solid #e0e0e0;
        }

        .month-marker {
          padding: 0.75rem 0.5rem;
          text-align: center;
          border-right: 1px solid #e0e0e0;
          font-size: 0.75rem;
          font-weight: 700;
          color: #666;
        }

        .gantt-body {
          max-height: 600px;
          overflow-y: auto;
        }

        .gantt-body::-webkit-scrollbar {
          width: 8px;
        }

        .gantt-body::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        .gantt-body::-webkit-scrollbar-thumb {
          background: #F5A623;
          border-radius: 4px;
        }

        .phase-group {
          border-bottom: 1px solid #e0e0e0;
        }

        .phase-row {
          display: grid;
          grid-template-columns: 300px 1fr;
          border-left: 4px solid transparent;
          transition: all 0.3s;
        }

        .phase-row:hover {
          background: #f9f9f9;
        }

        .gantt-row-label {
          padding: 1rem;
          border-right: 2px solid #e0e0e0;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .phase-toggle {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          width: 100%;
          text-align: left;
          background: none;
          border: none;
          cursor: pointer;
        }

        .phase-number {
          width: 40px;
          height: 40px;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 900;
          font-size: 1.25rem;
          flex-shrink: 0;
        }

        .phase-info {
          flex: 1;
          min-width: 0;
        }

        .phase-name {
          font-weight: 800;
          color: #1A1A1A;
          font-size: 0.9rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .phase-meta {
          font-size: 0.75rem;
          color: #666;
          margin-top: 0.25rem;
        }

        .gantt-row-timeline {
          position: relative;
          background: linear-gradient(90deg, #fafafa 0%, #fafafa 50%, #f5f5f5 50%, #f5f5f5 100%);
          background-size: 11.11% 100%;
          min-height: 50px;
        }

        .task-row .gantt-row-timeline {
          background: linear-gradient(90deg, #ffffff 0%, #ffffff 50%, #fafafa 50%, #fafafa 100%);
          background-size: 11.11% 100%;
          min-height: 45px;
        }

        .phase-bar {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          height: 32px;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.85;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.3s;
        }

        .phase-bar:hover {
          opacity: 1;
          transform: translateY(-50%) scale(1.02);
        }

        .phase-bar-label {
          color: white;
          font-weight: 900;
          font-size: 0.75rem;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .tasks-container {
          overflow: hidden;
          background: #fafafa;
        }

        .task-row {
          display: grid;
          grid-template-columns: 300px 1fr;
          border-top: 1px solid #e8e8e8;
        }

        .task-row:hover {
          background: #fafafa;
        }

        .task-label {
          padding: 0.75rem 1rem;
        }

        .task-id {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 0.75rem;
          flex-shrink: 0;
        }

        .task-name {
          font-size: 0.85rem;
          color: #1A1A1A;
          font-weight: 600;
        }

        .task-bar {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          height: 24px;
          border-radius: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.8;
          transition: all 0.3s;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .task-bar:hover {
          opacity: 1;
          transform: translateY(-50%) scale(1.05);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .task-bar-label {
          color: white;
          font-weight: 700;
          font-size: 0.7rem;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          z-index: 9998;
          backdrop-filter: blur(4px);
        }

        .modal-content {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          border-radius: 1rem;
          width: 90%;
          max-width: 600px;
          z-index: 9999;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
        }

        .modal-header {
          padding: 1.5rem;
          border-radius: 1rem 1rem 0 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .modal-task-id {
          width: 48px;
          height: 48px;
          border-radius: 0.75rem;
          background: rgba(255, 255, 255, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 900;
          font-size: 1.5rem;
        }

        .modal-close {
          background: rgba(255, 255, 255, 0.2);
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s;
          color: white;
        }

        .modal-close:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        .modal-body {
          padding: 1.5rem;
        }

        .modal-detail {
          padding: 0.75rem 0;
          border-bottom: 1px solid #f0f0f0;
          color: #333;
        }

        .modal-detail:last-child {
          border-bottom: none;
        }

        .modal-detail strong {
          color: #1A1A1A;
          font-weight: 700;
          margin-right: 0.5rem;
        }

        .legend-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
          margin-top: 2rem;
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .legend-color {
          width: 48px;
          height: 48px;
          border-radius: 0.75rem;
          flex-shrink: 0;
        }

        .legend-name {
          font-weight: 700;
          color: white;
          font-size: 0.9rem;
        }

        .legend-tasks {
          font-size: 0.75rem;
          color: #999;
        }
      `}} />
    </div>
  );
};

export default RoadmapGantt;
